var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSearchLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0203 11.0775L14.8755 13.9327L13.9327 14.8755L11.0775 12.0203C10.0509 12.8417 8.74901 13.333 7.33301 13.333C4.02101 13.333 1.33301 10.645 1.33301 7.33301C1.33301 4.02101 4.02101 1.33301 7.33301 1.33301C10.645 1.33301 13.333 4.02101 13.333 7.33301C13.333 8.74901 12.8417 10.0509 12.0203 11.0775ZM10.6828 10.5829C11.498 9.74274 11.9997 8.59674 11.9997 7.33301C11.9997 4.75467 9.91134 2.66634 7.33301 2.66634C4.75467 2.66634 2.66634 4.75467 2.66634 7.33301C2.66634 9.91134 4.75467 11.9997 7.33301 11.9997C8.59674 11.9997 9.74274 11.498 10.5829 10.6828L10.6828 10.5829Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearchLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search-line.abea6b18.svg";
export { ForwardRef as ReactComponent };